import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/data-connector/redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { ErrorMessage, Field, Formik, Form } from 'formik';
import CustomLoader from '../common/CustomLoader';
import CustomSelect from '../home/collections/CustomSelect';
import ParentContentCard from '../common/ParentContentCard';
import { dropdownsForSource } from '../../common/utils/data_source-util';
import FormFieldWithLabel from '../common/FormFieldWithLabel';
import {
  findFieldsByCollectionId,
  findTableByCollectionId,
  getFieldDataTypeValue,
  transformData,
  convertFields,
} from './common/common_utils';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';

export class AirtableCollectionsUpdate extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    fieldDatatypes: [],
    airtableCollection: '',
    selectedCollection: '',
  };
  async componentDidMount() {
    const { match, actions } = this.props;
    const { externalDbUuid, projectId, version, collectionId } = match.params;
    await actions.loadExternalDatabaseForAirtable({
      projectId,
      externalDbUuid,
      version,
    });
    this.setState({ airtableCollection: this.props.dataConnector.externalDbAirtable });
    const { setting, completeData } = this.state.airtableCollection;
    const { database } = completeData;
    await actions.airtableGetTables({
      headers: setting,
      workspaceId: database.id,
      projectId,
      version,
    });
    if (this.props.dataConnector.airtableTables) {
      const { airtableTables } = this.props.dataConnector;
      const transformedResult = transformData(airtableTables);
      const newResult = findFieldsByCollectionId(transformedResult, collectionId);
      await actions.airtableUpdateExternalDatabase({
        projectId,
        externalDbUuid,
        fields: newResult,
        version,
        collectionId: collectionId,
      });
      await actions.loadExternalDatabaseForAirtable({
        projectId,
        externalDbUuid,
        version,
      });
      const { externalDbAirtable } = this.props.dataConnector;
      const selectedTable = await findTableByCollectionId(externalDbAirtable, collectionId);
      this.setState({ selectedCollection: selectedTable });
    }
  }
  handleCancel = () => {
    const { match, history } = this.props;
    const { externalDbUuid, projectId, version } = match.params;
    history.push(`/2.0/data-connector/${version}/v/${projectId}/airtable-edit/${externalDbUuid}`);
  };
  handleSave = async () => {
    const { selectedCollection, fieldDatatypes, airtableCollection } = this.state;
    const { setting, completeData } = airtableCollection;
    const { database } = completeData;
    const { actions, match } = this.props;
    const fieldData = selectedCollection.fields;
    const result = {};
    Object.keys(fieldData).map((fieldName, index) => {
      result[fieldName] = fieldDatatypes[fieldName]
        ? fieldDatatypes[fieldName].value
        : fieldData[fieldName];
    });
    const newResult = convertFields(result);
    const { projectId, externalDbUuid, version } = match.params;
    const data = {
      version,
      collectionTitle: selectedCollection.collectionName,
      willPersist: false,
      fields: newResult,
      projectId,
      externalDatabaseId: externalDbUuid,
      setting,
      baseId: database.id,
      tableId: selectedCollection.collectionId,
    };
    await actions.updateCollectionForAirtable(data);
    await actions.airtableUpdateExternalDatabase({
      projectId,
      externalDbUuid,
      fields: newResult,
      version,
      collectionId: selectedCollection.collectionId,
    });
    this.handleCancel();
  };
  handleFieldChange = (fieldName, selectedValue) => {
    const updatedResult = { ...this.state.fieldDatatypes };
    updatedResult[fieldName[0]] = selectedValue;
    this.setState({ fieldDatatypes: updatedResult });
  };
  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />;
        </CommonPageComponent>
      );
    }

    const { dataConnector } = this.props;
    const {
      loadExternalDatabaseForAirtablePending,
      airtableUpdateExternalDatabasePending,
      updateCollectionForAirtablePending,
      airtableGetTablesPending,
    } = dataConnector;

    const { selectedCollection } = this.state;
    const fieldData = selectedCollection ? selectedCollection.fields : null;
    return fieldData ? (
      <CommonPageComponent>
        <ParentContentCard
          title={'Choose Collection for Create Or Skip via Airtable'}
          icon={'collection'}
        >
          <Formik initialValues={{ collectionTitle: selectedCollection.collectionName }}>
            {({ values, handleChange, setFieldValue }) => (
              <Form className="ml-5">
                <div className="col-md-11 col-lg-11 col-sm-12 col-xs-12">
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Collection Name"
                      icon="text"
                      infoIcon={true}
                      infoDescription={'Airtable collection name'}
                    >
                      <Field
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Collection Name"
                        readOnly
                        value={selectedCollection.collectionName}
                      />
                    </FormFieldWithLabel>
                  </div>

                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Collection Title"
                      icon="text"
                      infoIcon={true}
                      infoDescription={'Enter name for the collection name if  you want to change'}
                      value={selectedCollection.collectionName}
                    >
                      <Field
                        type="text"
                        name="collectionTitle"
                        className="form-control form-control-sm"
                        placeholder="Collection Title"
                      />
                      <ErrorMessage name="collectionTitle" component="p" className="text-danger" />
                    </FormFieldWithLabel>
                  </div>
                  <hr style={{ marginBottom: '20px', visibility: 'hidden' }} />
                  <div className="mt-2">
                    <h5>
                      <b>Field Type Mapping</b>
                    </h5>
                  </div>
                  <div
                    className="table-responsive"
                    style={{
                      overflow: 'visible',
                      maxHeight: 'fit-content',
                      marginBottom: '10px',
                    }}
                  >
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th style={{ width: '50%' }}>Fields</th>
                          <th style={{ width: '50%' }}>Types</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Object.keys(fieldData).map((fieldName, index) => (
                          <tr key={index}>
                            <td style={{ width: '50%' }}>{fieldName}</td>
                            <td style={{ width: '50%' }}>
                              <CustomSelect
                                name={fieldName}
                                isMulti={false}
                                onChange={setFieldValue}
                                onChangeValue={this.handleFieldChange}
                                options={dropdownsForSource}
                                value={getFieldDataTypeValue(
                                  fieldName,
                                  fieldData,
                                  this.state.fieldDatatypes,
                                )}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="d-flex justify-content-between">
                    <button
                      className="btn btn-outline-secondary btn-md"
                      title="Cancel"
                      type="button"
                      onClick={this.handleCancel}
                    >
                      <i className="wb webconnect-times"></i> Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-theme-submit btn-md"
                      title="Save Collection"
                      onClick={this.handleSave}
                      disabled={
                        updateCollectionForAirtablePending || airtableUpdateExternalDatabasePending
                      }
                    >
                      <i className="wb webconnect-save-regular"></i> Update
                      <CustomLoader
                        loading={
                          updateCollectionForAirtablePending ||
                          airtableUpdateExternalDatabasePending
                        }
                      />
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </ParentContentCard>
      </CommonPageComponent>
    ) : (
      <CommonPageComponent>
        <div className="text-center">
          <CustomLoader
            loading={loadExternalDatabaseForAirtablePending || airtableGetTablesPending}
            size="20px"
            color="#303453"
          />
        </div>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AirtableCollectionsUpdate);
